var IFrameAllowOptions;
(function (IFrameAllowOptions) {
    /**
     * Allows access the Accelerometer interface
     */
    IFrameAllowOptions["ACCELEROMETER"] = "accelerometer";
    /**
     * Allows access the AmbientLightSensor interface
     */
    IFrameAllowOptions["AMBIENT_LIGHT_SENSOR"] = "ambient-light-sensor";
    /**
     * Allows to autoplay video and audio files
     */
    IFrameAllowOptions["AUTOPLAY"] = "autoplay";
    /**
     * Allows access to the Battery Status API
     */
    IFrameAllowOptions["BATTERY"] = "battery";
    /**
     * Allows access to the camera
     */
    IFrameAllowOptions["CAMERA"] = "camera";
    /**
     * Allows access to fullscreen mode
     */
    IFrameAllowOptions["FULLSCREEN"] = "fullscreen";
    /**
     * Allows access to the Geolocation API
     */
    IFrameAllowOptions["GEOLOCATION"] = "geolocation";
    /**
     * Allows access to the Sensors API Gyroscope interface
     */
    IFrameAllowOptions["GYROSCOPE"] = "gyroscope";
    /**
     * Allows access to the Sensors API Magnetometer interface
     */
    IFrameAllowOptions["MAGNETOMETER"] = "magnetometer";
    /**
     * Allows access to the device microphone
     */
    IFrameAllowOptions["MICROPHONE"] = "microphone";
    /**
     * Allows access to the Web MIDI API
     */
    IFrameAllowOptions["MIDI"] = "midi";
    /**
     * Allows access to the Payment Request API
     */
    IFrameAllowOptions["PAYMENT"] = "payment";
    /**
     * Allows access to the WebUSB API
     */
    IFrameAllowOptions["USB"] = "usb";
    /**
     * Allows access to the Vibration API
     */
    IFrameAllowOptions["VIBRATE"] = "vibrate";
})(IFrameAllowOptions || (IFrameAllowOptions = {}));
var IFrameSandboxOptions;
(function (IFrameSandboxOptions) {
    /**
     * Allows downloading files through an <a> or <area> element with the download attribute, as well as through the navigation that leads to a download of a file.
     */
    IFrameSandboxOptions["ALLOW_DOWNLOADS"] = "allow-downloads";
    /**
     * Allows form submission.
     */
    IFrameSandboxOptions["ALLOW_FORMS"] = "allow-forms";
    /**
     * Allows the resource to open new modal windows.
     */
    IFrameSandboxOptions["ALLOW_MODALS"] = "allow-modals";
    /**
     * Allows the resource to lock the screen orientation.
     */
    IFrameSandboxOptions["ALLOW_ORIENTATION_LOCK"] = "allow-orientation-lock";
    /**
     * Allows the resource to use the Pointer Lock API.
     */
    IFrameSandboxOptions["ALLOW_POINTER_LOCK"] = "allow-pointer-lock";
    /**
     * Allows the resource to open new popups or tabs.
     */
    IFrameSandboxOptions["ALLOW_POPUPS"] = "allow-popups";
    /**
     * Allows the resource to open new windows that will not inherit the sandboxing.
     */
    IFrameSandboxOptions["ALLOW_POPUPS_TO_ESCAPE_SANDBOX"] = "allow-popups-to-escape-sandbox";
    /**
     * Allows the resource to start a presentation session.
     */
    IFrameSandboxOptions["ALLOW_PRESENTATION"] = "allow-presentation";
    /**
     * Allows the resource to maintain its origin.
     */
    IFrameSandboxOptions["ALLOW_SAME_ORIGIN"] = "allow-same-origin";
    /**
     * Allows the resource to run scripts.
     */
    IFrameSandboxOptions["ALLOW_SCRIPTS"] = "allow-scripts";
    /**
     * Allows a document loaded in the <iframe> to use the Storage Access API to request access to unpartitioned cookies.
     */
    IFrameSandboxOptions["ALLOW_STORAGE_ACCESS_BY_USER_ACTIVATION"] = "allow-storage-access-by-user-activation";
    /**
     * Allows the resource to navigate the top-level browsing context.
     */
    IFrameSandboxOptions["ALLOW_TOP_NAVIGATION"] = "allow-top-navigation";
    /**
     * Allows the resource to navigate the top-level browsing context, but only if initiated by a user gesture.
     */
    IFrameSandboxOptions["ALLOW_TOP_NAVIGATION_BY_USER_ACTIVATION"] = "allow-top-navigation-by-user-activation";
})(IFrameSandboxOptions || (IFrameSandboxOptions = {}));
export { IFrameAllowOptions, IFrameSandboxOptions, };
//# sourceMappingURL=iframe-constants.js.map